



















import Vue from "vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Suffix from "@/components/Atoms/Typography/Suffix/index.vue";
import { Data, Methods, Computed, Props } from "./types";
import { formatDate } from "@/helpers/date-helper";
import { sendGaEvent } from "@/helpers/ga-helper";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "FloatingNotificationButton",
  components: {
    Heading,
    Suffix
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ""
    },
    date: {
      type: String,
      required: true
    },
    unread: {
      type: Boolean,
      required: true
    },
    gaEventCategory: {
      type: String,
      required: true
    }
  },
  computed: {
    formattedDate() {
      return formatDate(this.date);
    },
    floatingNotificationButtonClass() {
      return {
        "floatingNotificationButton--unread": this.unread
      };
    }
  },
  methods: {
    handleClick() {
      sendGaEvent(this, {
        gaEventLabel: {
          id: this.id,
          title: this.title
        }
      });
      this.$emit("click");
    }
  }
});
